import {
    numberFormatter,
    moneyFormatter,
    percentageBarFormatter,
    fractionPercentageBarFormatter,
    fractionPercentageBarCeilingFormatter,
    shortDateFormatter,
    healthAlertFormatter,
    healthColorAlertFormatter,
    growthFormatter,
    removeURIEncode,
    currentFormatter,
    integerFormatter,
    dateFormatter,
    deviceHealthFormatter,
    booleanFormatter,
    growthTrendIconFormatter,
    percentageGrowthFormatter, ServiceNowButton
} from "../../gridFormatters";
import { roundToNearestHundredth, wtAvg, wtPctAvg } from "../../math";
import { recursiveRowNodeSearch } from "../../gridUtils";

export const allDeviceDefs = [
    {field: "device_name", headerName: "Device Name", sort: 'asc'},
    {field: "device_type_description", 'headerName': "Type"},
    {field: "context", headerName: "Context", "hide": true},
    {field: "array_status", headerName: "Status"},
    {
        field: "collection_date",
        headerName: "Collection Date",
        cellRenderer: dateFormatter
    },
    {
        field: "upload_date",
        headerName: "Last Upload Date",
        cellRenderer: dateFormatter
    },
    {
        field: "days_old",
        headerName: "Days Old",
        filter: "agNumberColumnFilter",
        cellRenderer: currentFormatter,
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        }
    },
    {field: "firmware", headerName: "Firmware"}
];

export const chargebackGridDefs = [
    {
        field: "device_name",
        headerName: "Array",
        enableRowGroup: true,
    },
    {
        field: "business_unit",
        headerName: "BU",
        enableRowGroup: true,
    },
    {
        field: "classification",
        headerName: "Classification",
        enableRowGroup: true,
    },
    {
        field: "datacenter",
        headerName: "Data Center",
        enableRowGroup: true,
    },
    {
        field: "application",
        headerName: "Application",
        enableRowGroup: true,
    },
    {
        field: "resource_name",
        headerName: "Resource Name",
        enableRowGroup: true,
    },
    {
        field: "resource_type",
        headerName: "Resource Type",
        enableRowGroup: true,
    },
    {
        field: "lun_name",
        headerName: "Lun Name",
        enableRowGroup: true,
    },
    {
        field: "owner",
        headerName: "Owner",
        enableRowGroup: true,
    },
    {
        field: "usable",
        headerName: "Usable",
        enableValue: true,
        type: "numericColumn",
        aggFunc: "sum",
        cellRenderer: numberFormatter,
    },
    {
        field: "used_pct",
        type: "numericColumn",
        headerName: "% Used",
        enableValue: true,
        aggFunc: "avg",
        cellRenderer: percentageBarFormatter,
    },
    {
        field: "total_used",
        type: "numericColumn",
        enableValue: true,
        headerName: "Total Used",
        aggFunc: "sum",
        cellRenderer: numberFormatter,
    },
    {
        field: "price_per_gb",
        type: "numericColumn",
        headerName: "Price per GB",
        enableValue: true,
        enableRowGroup: false,
        aggFunc: "max",
        cellRenderer: moneyFormatter,
    },
    {
        field: "total_cost",
        type: "numericColumn",
        enableValue: true,
        enableRowGroup: true,
        headerName: "Total Cost",
        aggFunc: "sum",
        cellRenderer: moneyFormatter,
    },
    {
        field: "current",
        headerName: "Days Old",
        filter: "agSetColumnFilter",
        hide: true,
        cellRenderer: currentFormatter,
        cellStyle: {
            textAlign: "center"
        }
    }
];
export const overUtilGridDefs = [
    {
        field: "source",
        headerName: "Source",
        enableRowGroup: true
    },
    {
        field: "device_name",
        headerName: "Array Name",
        enableRowGroup: true
    },
    {
        field: "operational_category",
        headerName: "Category",
        enableRowGroup: true
    },
    {
        field: "application",
        headerName: "Application",
        enableRowGroup: true
    },
    {
        field: "resource_name",
        headerName: "Name",
        enableRowGroup: true
    },
    {
        field: "trend",
        headerName: "Trend",
        cellRenderer: 'agSparklineCellRenderer',
        cellRendererParams: {
            sparklineOptions: {
                axis: {
                    type: 'number'
                }
            }
        },

    },
    {
        field: "util_pct",
        type: "numericColumn",
        headerName: "% Used",
        enableValue: true,
        aggFunc: "avg",
        cellRenderer: percentageBarFormatter
    },
    {
        field: "usable",
        headerName: "Usable",
        enableValue: true,
        type: "numericColumn",
        aggFunc: "sum",
        cellRenderer: numberFormatter
    },
    {
        field: "used",
        type: "numericColumn",
        enableValue: true,
        headerName: "Used",
        aggFunc: "sum",
        cellRenderer: numberFormatter

    }
];
export const allPoolsDefs = [
    {
        field: "device_name",
        headerName: "Device Name",
        enableRowGroup: true,
    },
    {
        field: "device_type_description",
        headerName: "Device Type",
    },
    {
        field: "device_type",
        headerName: "Device Type Code",
        hide: true,
    },
    {
        field: "pool_name",
        headerName: "Pool Name",
        enableRowGroup: true,
    },
    {
        field: "capacity_gb",
        type: "numericColumn",
        headerName: "Size",
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        cellRenderer: integerFormatter,
    },
    {
        field: "pool_used",
        type: "numericColumn",
        headerName: "Used",
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        cellRenderer: integerFormatter,
        allowedAggFuncs: [
            "sum"
        ],
    },
    {
        field: "pct_pool",
        headerName: "% Used",
        filter: "agNumberColumnFilter",
        cellRenderer: percentageBarFormatter,
        aggFunc: (params) => wtPctAvg(params, "pool_used", "capacity_gb"),
    },
      {
        field: "pool_alloc",
        type: "numericColumn",
        headerName: "Allocated",
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        cellRenderer: integerFormatter,
        allowedAggFuncs: [
            "sum"
        ],
    },
      {
        field: "pct_alloc",
        headerName: "% Allocated",
        filter: "agNumberColumnFilter",
        cellRenderer: percentageBarFormatter,
        aggFunc: (params) => wtPctAvg(params, "pool_alloc", "capacity_gb"),
    },
    {
        field: "pool_free",
        type: "numericColumn",
        headerName: "Free",
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        cellRenderer: integerFormatter,
        allowedAggFuncs: [
            "sum"
        ],
        hide: true,
    },
    {
        field: "controller_name",
        headerName: "Controller",
        hide: true,
    },
    {
        field: "display_name",
        headerName: "Display Name",
        hide: true,
    },
    {
        field: "replication",
        headerName: "Replication",
        hide: true,
    },
    {
        field: "current",
        headerName: "Days Old",
        filter: "agNumberColumnFilter",
        cellRenderer: currentFormatter,
        cellStyle: {
            textAlign: "center"
        },
        hide: true,
    },
];

export const allNodesDefs = [
    {
        field: "device_name",
        headerName: "Array Name",
        filter: "agSetColumnFilter",
    },
    {
        field: "device_type",
        headerName: "Device Type",
    },
    {
        field: "node_name",
        headerName: "Node",
    },
    {
        field: "used",
        headerName: "Used",
        filter: "agNumberColumnFilter",
        cellRenderer: integerFormatter,
    },
    {
        field: "usable",
        headerName: "Usable",
        filter: "agNumberColumnFilter",
        cellRenderer: integerFormatter,
    },
    {
        field: "allocated",
        headerName: "Allocated",
        filter: "agNumberColumnFilter",
        cellRenderer: integerFormatter,
    },
    {
        field: "percent_used",
        headerName: "% Used",
        filter: "agNumberColumnFilter",
        cellRenderer: percentageBarFormatter,
        aggFunc: params => wtPctAvg(params, "used", "usable"),
    },
    {
        field: "percent_allocated",
        headerName: "% Allocated",
        filter: "agNumberColumnFilter",
        cellRenderer: percentageBarFormatter,
        aggFunc: params => wtPctAvg(params, "allocated", "usable"),
    },
    {
        field: "serial_number",
        headerName: "Serial Number",
    },
    {
        field: "free",
        headerName: "Free",
        filter: "agNumberColumnFilter",
        cellRenderer: integerFormatter,
        hide: true,
    },
    {
        field: "data_center",
        headerName: "Data Center",
        hide: true,
    },
    {
        field: "operational_category",
        headerName: "Category",
        hide: true,
    },
    {
        field: "classification",
        headerName: "Classification",
        hide: true,
    },
    {
        field: "application",
        headerName: "Application",
        hide: true,
    },
    {
        field: "current",
        headerName: "Days Old",
        filter: "agNumberColumnFilter",
        hide: true,
        cellRenderer: currentFormatter,
        cellStyle: {
            textAlign: "center"
        },
    },
];

export const allVolumesDefs = [
    {
        field: "device_name",
        headerName: "Device Name",
    },
    {
        field: "device_type_description",
        headerName: "Device Type",
    },
    {
        field: "device_type",
        headerName: "Device Type Code",
        hide: true,
    },
    {
        field: "volume_name",
        headerName: "Volume Name",
    },
    {
        field: "volume_alloc",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        headerName: "Allocated",
        aggFunc: "sum",
        cellRenderer: integerFormatter,
    },
    {
        field: "volume_used",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        headerName: "Used",
        aggFunc: "sum",
        cellRenderer: integerFormatter,
    },
    {
        field: "volume_iops",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        headerName: "IOPS",
        aggFunc: "sum",
    },
    {
        field: "volume_latency",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        headerName: "Latency",
        aggFunc: (params) => wtAvg(params, "volume_latency", "volume_iops"),
    },
    {
        field: "pct_volume",
        headerName: "% Volume",
        filter: "agNumberColumnFilter",
        aggFunc: (params) => wtPctAvg(params, "volume_used", "latest_volume_used + latest_volume_free"),
        cellRenderer: percentageBarFormatter,
    },
    {
        field: "used_growth_pct",
        headerName: "Used Growth %",
        filter: "agNumberColumnFilter",
        aggFunc: (params) => wtPctAvg(params, "used_growth_gb", "volume_used"),
        cellRenderer: percentageBarFormatter,
    },
    {
        field: "used_growth_gb",
        headerName: "Used Growth (GiB)",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
    },
    {
        field: "controller_name",
        headerName: "Controller",
        hide: true,
    },
    {
        field: "display_name",
        headerName: "Display Name",
        hide: true,
    },
    {
        field: "pool_name",
        headerName: "Pool Name",
        hide: true,
    },
    {
        field: "current",
        headerName: "Days Old",
        filter: "agSetColumnFilter",
        cellRenderer: currentFormatter,
        cellStyle: {
            textAlign: "center"
        },
        hide: true,
    },
    {
        field: "earliest_volume_used",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        headerName: "Earliest Volume Used",
        aggFunc: "sum",
        cellRenderer: integerFormatter,
        hide: true,
    },
    {
        field: "latest_volume_used",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        headerName: "Latest Volume Used",
        aggFunc: "sum",
        cellRenderer: integerFormatter,
        hide: true,
    },
    {
        field: "earliest_volume_free",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        headerName: "Earliest Volume Free",
        aggFunc: "sum",
        cellRenderer: integerFormatter,
        hide: true,
    },
    {
        field: "latest_volume_free",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        headerName: "Latest Volume Free",
        aggFunc: "sum",
        cellRenderer: integerFormatter,
        hide: true,
    },
    {
        field: "earliest_volume_alloc",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        headerName: "Earliest Volume Allocation",
        aggFunc: "sum",
        cellRenderer: integerFormatter,
        hide: true,
    },
    {
        field: "latest_volume_alloc",
        type: "numericColumn",
        headerName: "Latest Volume Allocation",
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        cellRenderer: integerFormatter,
        hide: true,
    },
    {
        field: "free_growth_pct",
        headerName: "Free Growth %",
        filter: "agNumberColumnFilter",
        aggFunc: (params) => wtPctAvg(params, "free_growth_gb", "latest_volume_free"),
        cellRenderer: percentageBarFormatter,
        hide: true,
    },
    {
        field: "free_growth_gb",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        headerName: "Free Growth (GiB)",
        hide: true,
    }
];

export const allLunsDefs = [
    {
        field: "device_name",
        headerName: "Device Name",
        enableRowGroup: true
    },
    {
        field: "device_type_code",
        headerName: "Device Type",
        enableRowGroup: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        }
    },
    {
        field: "lun_name",
        headerName: "Lun Name",
        enableRowGroup: true
    },
    {
        field: "lun_alloc",
        type: "numericColumn",
        headerName: "Allocated",
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        cellRenderer: integerFormatter,
    },
    {
        field: "lun_used",
        type: "numericColumn",
        headerName: "Used",
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        cellRenderer: integerFormatter,
    },
    {
        field: "pct_lun",
        headerName: "% LUN",
        filter: "agNumberColumnFilter",
        aggFunc: params => wtPctAvg(params, "lun_used", "lun_alloc"),
        cellRenderer: percentageBarFormatter,
    },
    {
        field: "used_growth_pct",
        headerName: "Used Growth %",
        filter: "agNumberColumnFilter",
        aggFunc: "avg",
        cellRenderer: percentageBarFormatter,
    },
    {
        field: "used_growth",
        headerName: "Used Growth (GiB)",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
    },
    {
        field: "controller_name",
        headerName: "Controller",
        enableRowGroup: true,
        hide: true,
    },
    {
        field: "display_name",
        headerName: "Display Name",
        enableRowGroup: true,
        hide: true,
    },
    {
        field: "current",
        headerName: "Days Old",
        filter: "agNumberColumnFilter",
        cellRenderer: currentFormatter,
        cellStyle: {
            textAlign: "center"
        },
        hide: true,
    },
    {
        field: "pool_name",
        headerName: "Pool Name",
        enableRowGroup: true,
        hide: true,
    },
    {
        field: "volume_name",
        headerName: "Volume Name",
        enableRowGroup: true,
        hide: true,
    },
    {
        field: "earliest_lun_used",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        headerName: "Earliest Lun Used",
        aggFunc: "sum",
        cellRenderer: integerFormatter,
        hide: true,
    },
    {
        field: "latest_lun_used",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        headerName: "Latest Lun Used",
        aggFunc: "sum",
        cellRenderer: integerFormatter,
        hide: true,
    },
    {
        field: "earliest_lun_free",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        headerName: "Earliest Lun Free",
        aggFunc: "sum",
        cellRenderer: integerFormatter,
        hide: true,
    },
    {
        field: "latest_lun_free",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        headerName: "Latest Lun Free",
        aggFunc: "sum",
        cellRenderer: integerFormatter,
        hide: true,
    },
    {
        field: "earliest_lun_allocation",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        headerName: "Earliest Lun Allocation",
        aggFunc: "sum",
        cellRenderer: integerFormatter,
        hide: true,
    },
    {
        field: "latest_lun_allocation",
        type: "numericColumn",
        headerName: "Latest Lun Allocation",
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        cellRenderer: integerFormatter,
        hide: true,
    },
    {
        field: "earliest_iops",
        headerName: "Earliest IOPS",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "latest_iops",
        headerName: "Latest IOPS",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "earliest_avg_latency",
        headerName: "Earliest Latency",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        aggFunc: params => wtPctAvg(params, "earliest_avg_latency", "earliest_iops"),
        hide: true,
    },
    {
        field: "latest_avg_latency",
        headerName: "Latest Latency",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        aggFunc: params => wtPctAvg(params, "latest_avg_latency", "latest_iops"),
        hide: true,
    },
    {
        field: "iops_growth",
        headerName: "IOPS Growth",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        hide: true,
    },
    {
        field: "latency_growth",
        headerName: "Latency Growth",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        hide: true,
    }
];

export const allSharesDefs = [
    {
        field: "array_name",
        headerName: "Device Name",
        enableRowGroup: true
    },
    {
        field: "device_type_description",
        headerName: "Device Type",
        enableRowGroup: true,
    },
    {
        field: "share_name",
        headerName: "Share Name",
        enableRowGroup: true
    },
    {
        field: "volume_name",
        headerName: "Volume Name",
        enableRowGroup: true
    },
    {
        field: "pct_share",
        headerName: "% Volume",
        filter: "agNumberColumnFilter",
        enableValue: true,
        cellRenderer: percentageBarFormatter,
        aggFunc: (params) => wtPctAvg(params, "share_used", "share_alloc"),
    },
    {
        field: "share_used",
        type: "numericColumn",
        headerName: "Used",
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        cellRenderer: numberFormatter,
    },
    {
        field: "share_alloc",
        type: "numericColumn",
        headerName: "Allocated",
        filter: "agNumberColumnFilter",
        aggFunc: "sum",
        cellRenderer: numberFormatter,
    },
    {
        field: "controller_name",
        headerName: "Controller",
        enableRowGroup: true,
        hide: true,
    },
    {
        field: "display_name",
        headerName: "Display Name",
        enableRowGroup: true,
        hide: true,
    },
    {
        field: "svm_name",
        headerName: "SVM Name",
        enableRowGroup: true,
        hide: true,
    },
    {
        field: "current",
        headerName: "Days Old",
        filter: "agNumberColumnFilter",
        cellRenderer: currentFormatter,
        cellStyle: {
            textAlign: "center"
        },
        hide: true,
    },
];

export const storageSummaryDefs = [
    {
        field: "pool_name",
        headerName: "Pool Name",
        cellStyle: {
            textAlign: "left"
        },
        enableRowGroup: true
    },
    {
        field: "volume_name",
        headerName: "Volume Name",
        cellStyle: {
            textAlign: "center"
        },
        enableRowGroup: true
    },
    {
        field: "disk_type",
        headerName: "Disk Type",
        cellStyle: {
            textAlign: "center"
        },
        enableRowGroup: true
    },
    {
        field: "volume_used",
        type: "numericColumn",
        headerName: "Volume Used",
        filter: "agNumberColumnFilter",
        cellStyle: {
            textAlign: "center"
        },
        cellRenderer: numberFormatter
    },
    {
        field: "volume_alloc",
        type: "numericColumn",
        headerName: "Volume Allocated",
        filter: "agNumberColumnFilter",
        cellStyle: {
            textAlign: "center"
        },
        cellRenderer: numberFormatter
    },
    {
        field: "pct_volume_used",
        headerName: "% Volume Used",
        cellRenderer: fractionPercentageBarFormatter,
        aggFunc: p => wtPctAvg(p, "volume_used", "volume_alloc") / 100,
        filter: "agNumberColumnFilter",
    },
    {
        field: "pool_size",
        type: "numericColumn",
        headerName: "Pool Size",
        filter: "agNumberColumnFilter",
        cellStyle: {
            textAlign: "center"
        },
        cellRenderer: numberFormatter
    },
    {
        field: "pool_used",
        type: "numericColumn",
        headerName: "Pool Used",
        filter: "agNumberColumnFilter",
        cellStyle: {
            textAlign: "center"
        },
        cellRenderer: numberFormatter
    },
    {
        field: "pool_alloc",
        type: "numericColumn",
        headerName: "Pool Alloc",
        filter: "agNumberColumnFilter",
        cellStyle: {
            textAlign: "center"
        },
        cellRenderer: numberFormatter
    },
    {
        field: "pct_alloc",
        headerName: "% Pool Allocated",
        cellRenderer: fractionPercentageBarFormatter,
        // % Pool Allocated should = (Pool Alloc/Pool Size) and can be over 100%
        aggFunc: p => wtPctAvg(p, "pool_alloc", "pool_size") / 100,
        filter: "agNumberColumnFilter",
    },
    {
        field: "pct_used",
        headerName: "% Pool Used",
        cellRenderer: fractionPercentageBarCeilingFormatter,
        aggFunc: p => wtPctAvg(p, "pool_used", "pool_size") / 100,
        // % Pool Used should = (Pool Used/Pool Size) and should be 0-100%
        filter: "agNumberColumnFilter",
    },
    {
        field: "volume_iops",
        headerName: "Volume IOPS",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        cellStyle: {
            textAlign: "center"
        },
        cellRenderer: numberFormatter
    },
    {
        field: "space_guarantee",
        headerName: "Space Guarantee",
        cellStyle: {
            textAlign: "center"
        },
        hide: true
    },
];

export const storageServerTypeDefs = [
    {
        field: "collection_date",
        headerName: "Collection Date",
        cellRenderer: shortDateFormatter,
        enableRowGroup: true
    },
    {
        field: "host_name",
        headerName: "Host Name",
        enableRowGroup: true
    },
    {
        field: "fibre_percent",
        type: "numericColumn",
        headerName: "% Fibre",
        filter: "agNumberColumnFilter",
        cellRenderer: percentageBarFormatter
    },
    {
        field: "sata_percent",
        type: "numericColumn",
        headerName: "% SATA",
        filter: "agNumberColumnFilter",
        cellRenderer: percentageBarFormatter
    },
    {
        field: "sas_percent",
        type: "numericColumn",
        headerName: "% SAS",
        filter: "agNumberColumnFilter",
        cellRenderer: percentageBarFormatter
    },
    {
        field: "ssd_percent",
        type: "numericColumn",
        headerName: "% SSD",
        filter: "agNumberColumnFilter",
        cellRenderer: percentageBarFormatter
    },
    {
        field: "unknown_percent",
        type: "numericColumn",
        headerName: "% Unknown",
        filter: "agNumberColumnFilter",
        cellRenderer: percentageBarFormatter
    },
    {
        field: "total_free",
        type: "numericColumn",
        headerName: "Total Free",
        filter: "agNumberColumnFilter",
        cellRenderer: numberFormatter
    },
    {
        field: "total_alloc",
        type: "numericColumn",
        headerName: "Total Allocated",
        filter: "agNumberColumnFilter",
        cellRenderer: numberFormatter
    }
];

export const spaceDiskTypeDefs = [
    {
        field: "disk_group_name",
        headerName: "Disk Group",
        cellStyle: {
            textAlign: "left"
        }
    },
    {
        field: "free_space_fibre",
        type: "numericColumn",
        headerName: "Fibre Free",
        filter: "agNumberColumnFilter",
        cellStyle: {
            textAlign: "right"
        }
    },
    {
        field: "free_space_sas",
        type: "numericColumn",
        headerName: "SAS Free",
        filter: "agNumberColumnFilter",
        cellStyle: {
            textAlign: "right"
        }
    },
    {
        field: "free_space_sata",
        type: "numericColumn",
        headerName: "SATA Free",
        filter: "agNumberColumnFilter",
        cellStyle: {
            textAlign: "right"
        }
    },
    {
        field: "free_space_ssd",
        type: "numericColumn",
        headerName: "SSD Free",
        filter: "agNumberColumnFilter",
        cellStyle: {
            textAlign: "right"
        },
        cellRenderer: numberFormatter
    },
    {
        field: "free_space_unknown",
        type: "numericColumn",
        headerName: "Unknown Free",
        filter: "agNumberColumnFilter",
        cellStyle: {
            textAlign: "right"
        }
    },
    {
        field: "free_space_total",
        type: "numericColumn",
        headerName: "Total Free",
        filter: "agNumberColumnFilter",
        cellStyle: {
            textAlign: "right"
        },
        cellRenderer: numberFormatter
    }
];

export const enterpriseHealthDefs = [
    {
        field: "device_name",
        headerName: "Device Name"
    },
    {
        field: "device_type_code",
        headerName: "Type",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        enableRowGroup: true
    },
    {
        field: "config_alert_level_str",
        headerName: "Configuration & Setup",
        cellStyle: {
            textAlign: "center"
        },
        cellRenderer: healthAlertFormatter,
        filter: "agSetColumnFilter"
    },
    {
        field: "balance_alert_level_str",
        headerName: "Balance",
        cellStyle: {
            textAlign: "center"
        },
        cellRenderer: healthAlertFormatter,
        filter: "agSetColumnFilter"
    },
    {
        field: "host_alert_level_str",
        headerName: "Server Volume Mapping",
        cellStyle: {
            textAlign: "center"
        },
        cellRenderer: healthAlertFormatter,
        filter: "agSetColumnFilter"
    },
    {
        field: "general_errors_alert_level_str",
        headerName: "Errors & Other Alerts",
        cellStyle: {
            textAlign: "center"
        },
        cellRenderer: healthAlertFormatter,
        filter: "agSetColumnFilter"
    },
    {
        field: "pool_alert_level_str",
        headerName: "Storage Layout",
        cellStyle: {
            textAlign: "center"
        },
        cellRenderer: healthAlertFormatter,
        filter: "agSetColumnFilter"
    },
    {
        field: "volume_snap_alert_level_str",
        headerName: "Volumes / Snapshots",
        cellStyle: {
            textAlign: "center"
        },
        cellRenderer: healthAlertFormatter,
        filter: "agSetColumnFilter"
    }
];

export const enterpriseAlertsDefs = [


    {
      field: "id",
        headerName: 'ID'
    },
    {
        field: "severity",
        headerName: "Severity",
        cellRenderer: healthColorAlertFormatter
    },
    {
        field: "device_name",
        headerName: "Device Name"
    },
    {
        field: "category",
        headerName: "Category",
    },
    {
        field: "alert",
        headerName: "Alert",
        cellRenderer: removeURIEncode,
    },
    {
        field: "description",
        headerName: "Description",
        cellRenderer: removeURIEncode,
    },
    {
        field: "acknowledged",
        headerName: "Acknowledged?",
        cellRenderer: booleanFormatter,
    },
    {
        field: "incident_id",
        headerName: "Service Now",
        cellRenderer: ServiceNowButton
    }
];

export const enterprisePerformanceDefs = [
    {
        field: "tier",
        headerName: "Tier",
        hide: true,
        type: "numericColumn",
        enableValue: true
    },
    {
        field: "device_name",
        headerName: "Device Name",
    },
    {
        field: "device_type_code",
        headerName: "Device Type",
        enableRowGroup: true,
    },
    {
        field: "data_center",
        headerName: "Data Ctr",
        enableRowGroup: true,
    },
    {
        field: "classification",
        headerName: "Classification",
        enableRowGroup: true,
    },
    {
        field: "beg_collection_date_formatted",
        headerName: "Collection Date Start",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellStyle: {
            textAlign: "left"
        },
        enableValue: true,
        enableRowGroup: true,
        hide: true
    },
    {
        field: "beg_usable_gb",
        headerName: "Usable Start",
        type: "numericColumn",
        enableValue: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        allowedAggFuncs: [
            "sum"
        ],
        hide: true,
        cellRenderer: numberFormatter
    },
    {
        field: "end_usable_gb",
        headerName: "Usable End",
        type: "numericColumn",
        enableValue: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        allowedAggFuncs: [
            "sum"
        ],
        cellRenderer: numberFormatter
    },
    {
        field: "usable_gb_growth",
        headerName: "Usable Growth",
        type: "numericColumn",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        enableValue: true,
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        allowedAggFuncs: [
            "sum"
        ],
        hide: true,
        cellRenderer: growthFormatter
    },
    {
        field: "beg_total_used",
        headerName: "Used Start",
        type: "numericColumn",
        enableValue: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        allowedAggFuncs: [
            "sum"
        ],
        hide: true,
        cellRenderer: numberFormatter
    },
    {
        field: "end_total_used",
        headerName: "Used End",
        type: "numericColumn",
        enableValue: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        allowedAggFuncs: [
            "sum"
        ],
        hide: true,
        cellRenderer: numberFormatter,
    },
    {
        field: "total_used_growth",
        headerName: "Used Growth",
        type: "numericColumn",
        enableValue: true,
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        allowedAggFuncs: [
            "sum"
        ],
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: growthFormatter
    },
    {
        field: "physical_used_growth",
        headerName: "Physical Used Growth",
        type: "numericColumn",
        enableValue: true,
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        allowedAggFuncs: [
            "sum"
        ],
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: growthFormatter
    },
    {
        field: "beg_total_free",
        headerName: "Free Start",
        type: "numericColumn",
        enableValue: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        allowedAggFuncs: [
            "sum"
        ],
        hide: true,
        cellRenderer: numberFormatter,
    },
    {
        field: "end_total_free",
        headerName: "Free End",
        type: "numericColumn",
        enableValue: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        allowedAggFuncs: [
            "sum"
        ],
        hide: true,
        cellRenderer: numberFormatter,
    },
    {
        field: "total_free_growth",
        headerName: "Free Growth",
        type: "numericColumn",
        enableValue: true,
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        allowedAggFuncs: [
            "sum"
        ],
        hide: true,
        cellRenderer: growthFormatter
    },
    {
        field: "beg_total_allocated",
        headerName: "Allocated Start",
        type: "numericColumn",
        enableValue: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        allowedAggFuncs: [
            "sum"
        ],
        hide: true,
        cellRenderer: numberFormatter,
    },
    {
        field: "end_total_allocated",
        headerName: "Allocated End",
        type: "numericColumn",
        enableValue: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        hide: true,
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        allowedAggFuncs: [
            "sum"
        ],
        "cellRenderer": numberFormatter
    },
    {
        field: "total_allocated_growth",
        headerName: "Allocated Growth",
        type: "numericColumn",
        enableValue: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        cellRenderer: growthFormatter,
        allowedAggFuncs: [
            "sum"
        ],
        hide: true
    },
    {
        field: "percent_used",
        headerName: "% Used Growth",
        cellStyle: {
            textAlign: "right"
        },
        type: "numericColumn",
        enableValue: true,
        aggFunc: params => {
            const allNodes = recursiveRowNodeSearch(params.rowNode);
            let begUsed = 0;
            let begUsble = 0;
            let endUsed = 0;
            let endUsble = 0;

            allNodes.forEach((node) => {
              begUsed += node?.beg_total_used ?? 0;
              begUsble += node?.beg_usable_gb ?? 0;

              endUsed += node?.end_total_used ?? 0;
              endUsble += node?.end_usable_gb ?? 0;
            });

            return roundToNearestHundredth((endUsed / endUsble - begUsed / begUsble) * 100)
        },
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: percentageGrowthFormatter
    },
    {
        field: "beg_iops",
        headerName: "IOPS Start",
        type: "numericColumn",
        enableValue: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        allowedAggFuncs: [
            "sum"
        ],
        hide: true,
        cellRenderer: numberFormatter,
    },
    {
        field: "end_iops",
        headerName: "IOPS End",
        type: "numericColumn",
        enableValue: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        allowedAggFuncs: [
            "sum"
        ],
        cellRenderer: numberFormatter,
    },
    {
        field: "beg_latency",
        headerName: "Latency Start",
        type: "numericColumn",
        enableValue: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellStyle: {
            textAlign: "right"
        },
        aggFunc: (params) => wtAvg(params, "beg_latency", "beg_iops"),
        hide: true
    },
    {
        field: "end_latency",
        headerName: "Latency End",
        type: "numericColumn",
        enableValue: true,
        aggFunc: (params) => wtAvg(params, "end_latency", "end_iops"),
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellStyle: {
            textAlign: "right"
        },
        cellRenderer: numberFormatter,
    },
    {
        field: "iops_growth",
        headerName: "IOPS Growth",
        type: "numericColumn",
        enableValue: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        allowedAggFuncs: [
            "sum"
        ],
        cellRenderer: growthFormatter
    },
    {
        field: "latency_change",
        headerName: "Latency Change",
        type: "numericColumn",
        enableValue: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellStyle: {
            textAlign: "right"
        },
        aggFunc: (params) => wtAvg(params, "latency_change", "end_iops"),
        cellRenderer: growthFormatter
    },
    {
        field: "display_name",
        headerName: "Display Name",
        hide: true,
        enableValue: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
    },
    {
        field: "geography",
        headerName: "Geography",
        hide: true,
        enableRowGroup: true,
        enableValue: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellStyle: {
            textAlign: "center"
        }
    },
    {
        field: "beg_physical_usable",
        headerName: "Physical Usable Start",
        hide: true,
        enableRowGroup: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        aggFunc: "sum",
        enableValue: true,
        cellStyle: {
            textAlign: "right"
        },
        cellRenderer: numberFormatter,
    },
    {
        field: "physical_usable",
        headerName: "Physical Usable End",
        hide: true,
        enableRowGroup: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        enableValue: true,
        cellStyle: {
            textAlign: "right"
        },
        aggFunc: "sum",
        cellRenderer: numberFormatter,
    },
    {
        field: "beg_physical_used",
        headerName: "Physical Used Start",
        hide: true,
        enableRowGroup: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        enableValue: true,
        cellStyle: {
            textAlign: "right"
        },
        aggFunc: "sum",
        cellRenderer: numberFormatter,
    },
    {
        field: "physical_used",
        headerName: "Physical Used End",
        hide: true,
        enableRowGroup: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        enableValue: true,
        cellStyle: {
            textAlign: "right"
        },
        allowedAggFuncs: [
            "sum"
        ],
        aggFunc: "sum",
        cellRenderer: numberFormatter,
    },
    {
        field: "pct_end_used",
        headerName: "% Used End",
        enableRowGroup: true,
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        aggFunc: params => {
            const allNodes = recursiveRowNodeSearch(params.rowNode);
            let endUsed = 0;
            let endUsble = 0;

            allNodes.forEach((node) => {
              endUsed += node?.end_total_used ?? 0;
              endUsble += node?.end_usable_gb ?? 0;
            });

            return roundToNearestHundredth((endUsed / endUsble) * 100)
        },
        cellRenderer: percentageBarFormatter
    }
];

export const deviceGridDefs = [
    {
        field: "type",
        headerName: "Type",
        enableRowGroup: true
    },
    {
        field: "size",
        headerName: "Size",
        enableValue: true,
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        cellRenderer: integerFormatter,
        enableRowGroup: true
    },
    {
        field: "speed",
        type: "numericColumn",
        headerName: "Speed",
        enableValue: true,
        filter: "agNumberColumnFilter",
        cellRenderer: integerFormatter,
    },
    {
        field: "spares",
        type: "numericColumn",
        headerName: "Spares",
        enableValue: true,
        filter: "agNumberColumnFilter",
        enableRowGroup: true
    },
    {
        field: "unassigned",
        type: "numericColumn",
        enableValue: true,
        filter: "agNumberColumnFilter",
        enableRowGroup: true,
        headerName: "Unassigned"
    },
    {
        field: "failed",
        type: "numericColumn",
        headerName: "Failed",
        filter: "agNumberColumnFilter",
        enableValue: true,
        enableRowGroup: true
    }
];

export const enterpriseGridDefs = [
    {
        field: "max_alert_level",
        headerName: "Max Alert Level",
        enableRowGroup: true,
        cellRenderer: deviceHealthFormatter,
        cellStyle: {
            textAlign: "center"
        },
        hide: true,
        filter: "agSetColumnFilter"
    },
    {
        field: "device_name",
        headerName: "Device Name",
    },
    {
        field: "display_name",
        headerName: "Display Name",
        enableValue: true,
        hide: true,
    },
    {
        field: "days_old",
        headerName: "Days Old",
        aggFunc: "sum",
        hide: true,
        cellRenderer: currentFormatter,
        cellStyle: {
            textAlign: "center"
        }
    },
    {
        field: "data_center",
        headerName: "Data Center",
        enableRowGroup: true,
    },
    {
        field: "device_type_description",
        headerName: "Type",
        filter: "agSetColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        enableRowGroup: true,
    },
    {
        field: "classification",
        headerName: "Classification",
        enableRowGroup: true,
    },
    {
        field: "total_allocated",
        headerName: "Alloc",
        type: "numericColumn",
        enableValue: true,
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: numberFormatter,
    },
    {
        field: "total_used",
        headerName: "Used",
        type: "numericColumn",
        enableValue: true,
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: numberFormatter,
    },
    {
        field: "usable_gb",
        headerName: "Usable",
        type: "numericColumn",
        enableValue: true,
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: numberFormatter,
    },
    {
        field: "percent_used",
        headerName: "% Used",
        type: "numericColumn",
        cellRenderer: percentageBarFormatter,
        enableValue: true,
        aggFunc: "overallAvgPct",
        cellStyle: {
            textAlign: "right"
        },
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
    },
    {
        field: "orphan_gb",
        headerName: "Orphan",
        type: "numericColumn",
        enableValue: true,
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        hide: true,
        cellRenderer: numberFormatter,
    },
    {
        field: "num_disk_groups",
        headerName: "Pools",
        type: "numericColumn",
        enableValue: true,
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        }
    },
    {
        field: "dedupe_gb",
        headerName: "Savings",
        type: "numericColumn",
        enableValue: true,
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        hide: true,
        cellRenderer: numberFormatter,
    },
    {
        field: "num_drives",
        headerName: "# Drives",
        type: "numericColumn",
        cellRenderer: integerFormatter,
        enableValue: true,
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        hide: true,
    },
    {
        field: "iops",
        headerName: "IOPS",
        type: "numericColumn",
        enableValue: true,
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: numberFormatter,
    },
    {
        field: "avg_latency",
        headerName: "Latency",
        type: "numericColumn",
        cellRenderer: numberFormatter,
        enableValue: true,
        aggFunc: "weightedByIOPs",
        cellStyle: {
            textAlign: "right"
        },
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        }
    },
    {
        field: "snap_gb",
        headerName: "Snaps",
        type: "numericColumn",
        enableValue: true,
        aggFunc: "sum",
        cellStyle: {
            textAlign: "right"
        },
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: numberFormatter,
    },
    {
        field: "growth",
        headerName: "Growth",
        cellStyle: {
            textAlign: "center"
        },
        type: "numericColumn",
        enableValue: true,
        aggFunc: (params) => wtAvg(params, "growth", "total_used"),
        cellRenderer: growthTrendIconFormatter,
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        }
    },
    {
        field: "firmware_level",
        headerName: "Firmware",
        enableRowGroup: true,
        hide: true,
    },
    {
        field: "data_reduction_ratio",
        headerName: "DRR",
        type: "numericColumn",
        enableValue: true,
        cellStyle: {
            textAlign: "right"
        },
        aggFunc: "avg",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        // Data Reduction Ratio should be always calculated on either parser or ETL. Enterprise Summary already have this field.
        // Aggregation needs to be calculated, though.
        // valueGetter: function(params) {
        //     return {
        //         total_used: params.data.total_used,
        //         physical_used: params.data.physical_used,
        //         toString: () => (params?.data?.total_used && params?.data?.physical_used) ? (params?.data?.total_used / params?.data?.physical_used).toString() : DrrDefaultValue
        //     }
        // },
        hide: true,
        cellRenderer: numberFormatter,
    },
    {
        field: "max_iops_capacity",
        headerName: "Max IOPs",
        type: "numericColumn",
        enableValue: true,
        cellStyle: {
            textAlign: "right"
        },
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        hide: true,
        cellRenderer: numberFormatter,
    },
    {
        field: "collection_date",
        headerName: "Collection Date",
        cellRenderer: shortDateFormatter,
        hide: true,
        enableRowGroup: true
    },
    {
        field: "date_created",
        headerName: "Upload Date",
        hide: true,
        cellRenderer: shortDateFormatter,
        enableRowGroup: true
    },
    {
        field: "raw_disk_gb",
        headerName: "Raw",
        type: "numericColumn",
        enableValue: true,
        cellStyle: {
            textAlign: "right"
        },
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        hide: true,
        cellRenderer: numberFormatter
    },
    {
        field: "mb_sec",
        headerName: "MB/Sec",
        type: "numericColumn",
        enableValue: true,
        cellStyle: {
            textAlign: "right"
        },
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        hide: true,
        cellRenderer: numberFormatter
    },
    {
        field: "num_orphans",
        headerName: "Orphan LUNs",
        type: "numericColumn",
        enableValue: true,
        cellStyle: {
            textAlign: "right"
        },
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        hide: true,
        cellRenderer: integerFormatter
    },
    {
        field: "num_hosts",
        headerName: "Hosts",
        type: "numericColumn",
        enableValue: true,
        cellStyle: {
            textAlign: "right"
        },
        hide: true,
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: integerFormatter
    },
    {
        field: "purchase_date",
        headerName: "Purchase Date",
        cellRenderer: shortDateFormatter,
        hide: true,
        enableRowGroup: true
    },
    {
        field: "end_of_maintenance_date",
        headerName: "End of Maint Date",
        cellRenderer: shortDateFormatter,
        hide: true,
        enableRowGroup: true
    },
    {
        field: "end_of_life_date",
        headerName: "End of Life Date",
        cellRenderer: shortDateFormatter,
        hide: true,
        enableRowGroup: true
    },
    {
        field: "contract_number",
        headerName: "Contract Number",
        hide: true,
        enableRowGroup: true
    },
    {
        field: "vendor",
        headerName: "Vendor",
        hide: true,
        enableRowGroup: true
    },
    {
        field: "tier",
        headerName: "Tier",
        hide: true,
        enableRowGroup: true
    },
    {
        field: "category",
        headerName: "Category",
        hide: true,
        enableRowGroup: true
    },
    {
        field: "operational_category",
        headerName: "Operational Category",
        hide: true,
        enableRowGroup: true
    },
    {
        field: "application",
        headerName: "Application",
        hide: true,
        enableRowGroup: true
    },
    {
        field: "volume_locked_free",
        headerName: "Volume Locked Free",
        type: "numericColumn",
        enableValue: true,
        hide: true,
        cellStyle: {
            textAlign: "right"
        },
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: numberFormatter
    },
    {
        field: "model",
        headerName: "Model",
        hide: true,
        enableRowGroup: true
    },
    {
        field: "serial_numbers",
        headerName: "Serial Number(s)",
        hide: true,
    },
    {
        field: "total_free",
        headerName: "Effective Free Space",
        type: "numericColumn",
        enableValue: true,
        cellStyle: {
            textAlign: "right"
        },
        aggFunc: "sum",
        hide: true,
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: numberFormatter
    },
    {
        field: "geography",
        headerName: "Geography",
        hide: true,
        enableRowGroup: true
    },
    {
        field: "physical_used",
        headerName: "Physical Used",
        type: "numericColumn",
        enableValue: true,
        cellStyle: {
            textAlign: "right"
        },
        aggFunc: "sum",
        hide: true,
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: numberFormatter
    },
    {
        field: "physical_usable",
        headerName: "Physical Usable",
        type: "numericColumn",
        enableValue: true,
        cellStyle: {
            textAlign: "right"
        },
        aggFunc: "sum",
        hide: true,
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer: numberFormatter
    },
    {
        field: "pct_commit",
        headerName: "% Committed",
        hide: true,
        cellRenderer: fractionPercentageBarFormatter,
        aggFunc: p => wtPctAvg(p, "total_allocated", "physical_usable") / 100,
        enableRowGroup: true
    },
    {
        field: "company_name",
        headerName: "Company Name",
        hide: true,
        enableRowGroup: true
    },
    {
        field: "virtualized",
        headerName: "Virtualized",
        hide: true,
        enableRowGroup: true,
        cellRenderer: booleanFormatter,
    },
];
